module.exports = __webpack_public_path__ + "media/images/form_table_sprite-94e385d2.png";